import { StyleSheet } from 'aphrodite';
import { brandPrimary, brandSecondary, titles } from '../../../../web/styles/colors';
import { cardStyle } from '../../../../web/styles/styles';

const interItemSpacing = 15;

export const styleSheet = StyleSheet.create({
	card: {
		margin: `${interItemSpacing}px 0 0 ${interItemSpacing}px`,
	},
	cards: {
		overflow: 'hidden',
	},
	cardsContent: {
		display: 'flex',
		flexWrap: 'wrap',
		margin: `${-interItemSpacing}px 0 0 ${-interItemSpacing}px`,
	},
	newButton: {
		...cardStyle,
		alignItems: 'center',
		border: `1px dashed ${brandSecondary}`,
		boxSizing: 'border-box',
		color: brandPrimary,
		display: 'flex',
		fontSize: 16,
		height: 122,
		justifyContent: 'center',
		position: 'relative',
		flexDirection: 'column',
		textAlign: 'center',
		flex: '1 0 0%',
	},
	newButtonIcon: {
		background: brandSecondary,
		borderRadius: '50%',
		color: '#fff',
		fontSize: 18,
		height: 40,
		marginBottom: 10,
		width: 40,
	},
	section: {
		marginBottom: 34,
	},
	sectionBumper: {},
	sectionTitle: {
		color: titles,
		fontSize: 18,
		marginBottom: 16,
	},
});
